import type { Field } from '@tcc/shared-data-lib';
import type { Product, ProductValidationValues, SeasonName } from 'store/types/types';

export enum RecommendationOptions {
  YOUR_ENTRY = 'your-entry',
  FVSS_RECOMMENDATION = 'fvss-recommendation',
}

export interface SeedDensityRecommendationInput {
  recommendationTarget: {
    id: string;
    type: 'FIELD';
  };
  targetYield: {
    v: number;
    u: string;
  };
  seedProductId?: string;
  optimizationType: 'AGRONOMIC';
  plantingDayOfYear?: string;
  nitrogenRate?: {
    v: number;
    u: string;
  };
  plantingRateInput?: {
    min: number;
    max: number;
    step: number;
  };
}

export interface Recommendation {
  targetYield: {
    v: number;
    u: string;
  };
  field: string;
  recommendation: {
    v: number;
    u: string;
  };
  curve: {
    plantingRate: number[];
    yield: number[];
    plantingRateUnit: string;
    yieldUnit: string;
  };
}

export enum SeedRecommendationOptimizationType {
  AGRONOMIC = 'AGRONOMIC',
  ECONOMIC = 'ECONOMIC',
}

export interface SeedDensityRecommendationQueryResponse {
  seedingRateRecommendation: Omit<Recommendation, 'recommendation'> | null;
}

export interface FieldData extends Field {
  hybrid?: Product;
  avgFixedPopulation?: string;
  seedCostPerBag?: string;
  targetYield?: string;
  recommendation?: Recommendation;
  selectedRecommendation?: RecommendationOptions;
}

export interface FormData {
  fields: FieldData[];
  plannedPlantingDate?: string;
  grainPrice?: string;
  season?: Extract<SeasonName, SeasonName.SUMMER | SeasonName.SAFRINHA>;
}

export type GetSchemaOptions = { productValidationValues?: ProductValidationValues; currency: string }
